/* Quarry — scroll reveal. Progressive enhancement only: the .js-reveal class
   is what hides anything, and it is added here, so a script failure leaves the
   page fully visible rather than blank. */
(function () {
  var SEL = '.qpur__head,.qrow__head,.qladder__head,.qstate__lead,.qfeat__inner,' +
            '.qladder__item,.qcard,.qstate__point';
  if (!('IntersectionObserver' in window)) return;   // no observer, no hiding
  document.documentElement.classList.add('js-reveal');
  window.__quarryRevealReady = true;   // tells the head guard not to un-hide

  function start() {
    var els = document.querySelectorAll(SEL);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var sibs = el.parentElement ? Array.prototype.slice.call(el.parentElement.children) : [];
        var i = sibs.indexOf(el);
        el.style.transitionDelay = (i > 0 ? Math.min(i, 6) * 70 : 0) + 'ms';
        el.classList.add('is-revealed');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    els.forEach(function (el) { io.observe(el); });

    /* Anything already on screen at load reveals immediately, and a hard
       failsafe un-hides everything after 3s so nothing can stay invisible. */
    setTimeout(function () {
      document.querySelectorAll(SEL).forEach(function (el) { el.classList.add('is-revealed'); });
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
